import React from "react";
import { node, oneOf, string } from "prop-types";
import Icon from "@insightfulscience/atomic-react/Icon";
import iconNames from "@insightfulscience/atomic-react/Icon/names";
import { Col, Row } from "../Grid";

export const WistiaVideoBlockDetailFrame = ({ children }) => (
	<Col md={8} lg={8}>
		{children}
	</Col>
);

WistiaVideoBlockDetailFrame.propTypes = {
	children: node.isRequired,
};

export const WistiaVideoBlockDetailInfo = ({ title, children }) => (
	<Col md={4} lg={4}>
		<h3 className="wistia-block-detail__title">{title}</h3>
		{children}
	</Col>
);

WistiaVideoBlockDetailInfo.propTypes = {
	title: string.isRequired,
	children: node.isRequired,
};

export const WistiaVideoBlockDetailInfoItem = ({ title, children, iconName = "" }) => (
	<div className="wistia-block-detail__info">
		<div className="wistia-block-detail__info-title">
			{iconName && <Icon spacing={{ mr: 2 }} name={iconName} />}
			<span>{title}</span>
		</div>
		<div className="wistia-block-detail__info-description">{children}</div>
	</div>
);

WistiaVideoBlockDetailInfoItem.propTypes = {
	title: string.isRequired,
	iconName: oneOf(iconNames),
	children: node.isRequired,
};

const WistiaVideoBlockDetail = ({ dataId, children, ...props }) => {
	return (
		<div data-id={dataId} className="wistia-block-detail" {...props}>
			<Row mx my>
				{children}
			</Row>
		</div>
	);
};

WistiaVideoBlockDetail.propTypes = {
	dataId: string.isRequired,
	children: node.isRequired,
	videoEmbed: node,
};

export default WistiaVideoBlockDetail;
